<template>
  <div>
    <filterlist></filterlist>
    <div class="main">
      <el-row class="padtb5">
        <el-col
          :span="1"
          class="font14 font600 col333 line28"
        >总价：</el-col>
        <el-col :span="23">
          <span
            v-for="(item,index) in mmtotalList"
            :key="index"
            :class="[mmtotal==index?'colred':'','padlf8 marr15 font14 line28']"
            @click="changeType('mmtotal',item.val,index)"
          >{{item.name}}</span>
          <div class="disinline font14">
            <input
              type="text"
              class="inp"
              v-model="queryParam.pricess"
            > - <input
              type="text"
              class="inp"
              v-model="queryParam.pricese"
            ><span>元 确定</span>
          </div>
        </el-col>
      </el-row>
      <el-row class="padtb5">
        <el-col
          :span="1"
          class="font14 font600 col333 line28"
        >面积：</el-col>
        <el-col :span="23">
          <span
            v-for="(item,index) in areaList"
            :key="index"
            :class="[area==index?'colred':'','padlf8 marr15 font14 line28']"
            @click="changeType('area',item.val,index)"
          >{{item.name}}</span>
        </el-col>
      </el-row>

      <el-row class="padtb5">
        <el-col
          :span="1"
          class="font14 font600 col333 line28"
        >户型：</el-col>
        <el-col :span="23">
          <span
            v-for="(item,index) in layoutList"
            :key="index"
            :class="[queryParam.layout==item.val?'colred':'','padlf8 marr15 font14 line28']"
            @click="changeType('layout',item.val,index)"
          >{{item.name}}</span>
        </el-col>
      </el-row>

      <el-row class="padtb5">
        <el-col
          :span="1"
          class="font14 font600 col333 line28"
        >朝向：</el-col>
        <el-col :span="23">
          <span
            v-for="(item,index) in commonfun.Dictionaries('dictDirection')"
            :key="index"
            :class="[queryParam.Orientation==item.dictValue?'colred':'','padlf8 marr15 font14 line28']"
            @click="changeType('Orientation',item.dictValue,index)"
          >{{item.dictLabel}}</span>
        </el-col>
      </el-row>

      <el-row class="padtb5">
        <el-col
          :span="1"
          class="font14 font600 col333 line28"
        >更多：</el-col>
        <el-col
          :span="23"
          class="line28"
        >
          <el-select
            v-model="queryParam.dictStoreyHeight"
            placeholder="高低楼层"
            class="Screening"
            size="mini"
          >
            <el-option
              v-for="item in commonfun.Dictionaries('dictStoreyHeight')"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="queryParam.dictRenovation"
            placeholder="房源装修"
            class="Screening"
            size="mini"
          >
            <el-option
              v-for="item in commonfun.Dictionaries('dictRenovation')"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="queryParam.housePurpose"
            placeholder="房源用途"
            class="Screening"
            size="mini"
          >
            <el-option
              v-for="item in commonfun.Dictionaries('housePurpose')"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="queryParam.lift"
            placeholder="电梯"
            class="Screening"
            size="mini"
          >
            <el-option
              label="没有"
              value="0"
            ></el-option>
            <el-option
              label="有"
              value="1"
            ></el-option>
          </el-select>

        </el-col>
      </el-row>

    </div>

    <el-row class="wid1200 padt20">
      <el-col
        :span="19"
        class="lineb"
      >
        <el-row>
          <el-col :span="14">
            <div
              :class="Sorting_active==index?'Sorting_active Sorting':'Sorting' "
              v-for="(item,index) in sort"
              :key="index"
              @click="setSorting(index)"
            >{{item}}</div>
          </el-col>
          <el-col
            :span="10"
            class="textright"
          >
            共<span class="colred">{{total}}</span>套房源满足你的需求
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row
      class="wid1200"
      v-loading="loading"
    >
      <el-col :span="19">
        <ul>
          <li v-for="item in secondRoomList" :key="item.houseId">
            <el-row
              class="padtb20 borderb"
              @dblclick.native="toNext(item.houseId)"
            >
              <el-col :span="5">
                <div class="listmsg">
                  <img
                    src="/static/img/bf1.png"
                    alt
                  />
                </div>
              </el-col>
              <el-col
                :span="13"
                :offset="1"
                class="padl5"
              >
                <div class="font18 col333 font600 line50">{{item.title}}</div>
                <div class="font14 col666 line30">户型：{{item.apartmentS}}室 {{item.apartmentT}}厅 {{item.apartmentW}}卫 {{item.apartmentY}}阳台 </div>
                <div class="font14 col666 line30">面积：{{item.area}} ㎡</div>
                <div class="font14 col666 line30">地址：{{commonfun.returnRegion(item.districtCode)}} - {{commonfun.returnBussileList(item.business)}} / {{item.dictName}} </div>
                <div class="font14 col666 line30">楼层：{{commonfun.getDictLabel('dictStoreyHeight',item.height)}}</div>
              </el-col>
              <el-col
                :span="5"
                class="textright"
              >
                <div class="colfff line50">0</div>
                <div class="colred">
                  <span class="font24 font600">{{item.prices}}</span>
                  <span class="font14">万</span>
                </div>
                <div class="font14 col999 line30">参考单价：{{item.price}}元/㎡</div>
                <div class="font16 colred line30">400-920-5533 转 1212</div>
              </el-col>
            </el-row>
          </li>
        </ul>
      </el-col>
      <el-col
        :span="4"
        :offset="1"
      >
        <div class="marb20">
          <div class="tjList">
            <img
              src="/static/img/bf1.png"
              alt
            />
          </div>
          <div class="font14 col333 line30">
            幸福东方白桦林
          </div>
          <el-row>
            <el-col
              :span="14"
              class="font12 colred"
            ><span class="font600">660</span>m/元</el-col>
            <el-col
              :span="5"
              class="textright font12 colred"
            >在售</el-col>
            <el-col
              :span="5"
              class="textright font12 col346DEE"
            >住宅</el-col>
          </el-row>
        </div>
        <div class="marb20">
          <div class="tjList">
            <img
              src="/static/img/bf1.png"
              alt
            />
          </div>
          <div class="font14 col333 line30">
            幸福东方白桦林
          </div>
          <el-row>
            <el-col
              :span="14"
              class="font12 colred"
            ><span class="font600">660</span>m/元</el-col>
            <el-col
              :span="5"
              class="textright font12 colred"
            >在售</el-col>
            <el-col
              :span="5"
              class="textright font12 col346DEE"
            >住宅</el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <div class="textcenter padt20">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="size"
        :page-size="100"
        layout="prev, pager, next, jumper"
        :total="1000"
      >
      </el-pagination>
    </div>

  </div>
</template>

<script>
import filterlist from "@/components/filter";
export default {
  data() {
    return {
      size: 1,
      loading: true,
      limit: 10,
      orderField: "", //排序字段
      order: false, //排序方式
      tenant_code: "", //城市编码
      sort: ["默认排序", "单价"],
      Sorting_active: 0,
      total: 0,
      queryParam: {
        page: 1, //	当前页码
        limit: 10, //每页显示记录数
        orderField: "", //排序字段
        order: "", //排序方式，可选值(asc、desc)
        tenant_code: this.$store.state.tenantCode, //城市编码
        renovation: null, //装修类型 @dictRenovation
        pricess: null, //最低总价
        pricese: null, //最低总价
        areas: null, //最低面积
        areae: null, //最高面积
        layout: "", //居室
        Orientation: "", //朝向
        dictStoreyHeight: null, //高底层
        dictRenovation: null, //装修
        housePurpose: null, //用途
        lift: null //电梯
      },
      mmtotalList: [
        { val: "", name: "不限" },
        { val: "0-100", name: "<100万" },
        { val: "100-200", name: "100-200万" },
        { val: "200-300", name: "200-300万" },
        { val: "300-500", name: "300-500万" },
        { val: "500-800", name: "500-800万" },
        { val: "800-", name: "800万<" }
      ],
      mmtotal: "0",
      areaList: [
        { val: "-", name: "不限" },
        { val: "0-100", name: "<100m²" },
        { val: "100-300", name: "100-300m²" },
        { val: "300-500", name: "300-500m²" },
        { val: "500-1000", name: "500-1000m²" },
        { val: "1000-3000", name: "1000-3000m²" },
        { val: "3000-5000", name: "3000-5000m²" },
        { val: "5000-", name: "5000m²<" }
      ],
      area: "0",
      layout: "",
      layoutList: [
        { val: "", name: "不限" },
        { val: "1", name: "一居" },
        { val: "2", name: "二居" },
        { val: "3", name: "三居" },
        { val: "4", name: "四居" },
        { val: "5", name: "五居及以上" }
      ],
      OrientationList: [
        { val: "", name: "不限" },
        { val: "1", name: "朝东" },
        { val: "2", name: "朝北" },
        { val: "3", name: "朝西" },
        { val: "4", name: "朝南" }
      ],
      secondRoomList: []
    };
  },
  components: {
    filterlist
  },
  mounted() {
    this.getPageList();
  },
  methods: {
    toNext(id) {
      this.$router.push({
        path: "/SecondhandRoomDetail",
        name: "SecondhandRoomDetail",
        query: {
          id: id
        }
      });
    },
    handleCurrentChange(val) {
      this.queryParam.page = val;
    },
    getPageList() {
      this.loading = true;
      this.$get(this.$api.second.pageList, this.queryParam)
        .then(res => {
          if (res.code == 0) {
            this.total = res.data.total;
            this.secondRoomList = res.data.list;
            this.loading = false;
          }
        })
        .catch(err => {});
    },
    changeType(type, it, index) {
      this[type] = index;
      let obj = { label: type, val: it };
      this.changeVal(obj);
    },
    changeVal(val) {
      if (val.label == "type") {
        this.queryParam.type = val.val;
      } else if (val.label == "mmtotal") {
        this.queryParam.pricess = val.val.split("-")[0]; //最低单价
        this.queryParam.pricese = val.val.split("-")[1]; //最高单价
      } else if (val.label == "area") {
        this.queryParam.areas = val.val.split("-")[0];
        this.queryParam.areae = val.val.split("-")[1];
      } else if (val.label == "layout") {
        this.queryParam.layout = val.val;
      } else if (val.label == "Orientation") {
        this.queryParam.Orientation = val.val;
      }
    },
    Housefloor(val) {
      this.queryParam.dictStoreyHeight = val;
    }
  },
  watch: {
    queryParam: {
      handler(nowVal, oldVal) {
        this.getPageList();
      },
      deep: true
    }
  }
};
</script>

<style  lang="scss">
.listmsg {
  width: 12.5rem;
  height: 9.375rem;
  border-radius: 0.5rem;
  overflow: hidden;
}
.listmsg img {
  width: 100%;
  height: 100%;
}
.tjList {
  width: 100%;
  height: 8.4375rem;
  border-radius: 0.3rem;
  overflow: hidden;
}
.tjList img {
  width: 100%;
  height: 100%;
}
.active {
  background-color: #da251e;
  color: #fff !important;
}
.main {
  width: 75rem;
  margin: auto;
}
.pad5l7 {
  padding: 5px 6px;
  line-height: 28px;
}
.padlf8 {
  padding: 0px 8px;
}
.inp {
  width: 4.25rem;
  font-size: 0.875rem;
  padding: 0.1875rem 0.125rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/secondHand/secondHandList.vue